import React,  { useState }  from 'react'
import './NotificationCard.css'
import check from "../../../Assets/icons/check_circle_outline.svg"
import check_active from "../../../Assets/icons_active/check_circle.svg"


const NotificationCard = ({ title, message, time, date, isRead, handleReadStatus }) => {

    // const [isRead, setIsRead] = useState(false);

    // const handleReadStatus = () => {
    //     setIsRead(true); 
    // };

  return (
        <div className="notWrap">
                <div className={`notBody ${isRead ? 'read' : ''}`}>
                    <div className="leftPart">
                        <p className="notHeader">{title}</p>
                        <div className="notContent">{message}</div>
                    </div>
                    <div className='rightPart'>
                    <img 
                        className="unread" 
                        src={isRead ? check_active : check} 
                        alt="check" 
                        onClick={handleReadStatus} 
                    />
                        <div className='date'>{time} {date}</div>
                        
                    </div>
                </div>
            </div>
  )
}

export default NotificationCard